
export const apiErrorMessage = {
  networkError: 'サーバーとの通信に失敗しました。',
  sessionTimeout: 'ログイン情報が古いため、再ログインしてください。',
  badRequest: 'リクエストに問題があり処理されませんでした。',
  internalServerError: 'サーバで問題が発生し処理されませんでした。',
  unexpectedError: '予期しないエラーが発生しました。'
}
